import DoubleLeftOutlined from '@ant-design/icons/DoubleLeftOutlined';
import DoubleRightOutlined from '@ant-design/icons/DoubleRightOutlined';

interface TriggerProps {
  collapsed: boolean;
  onClick: () => void;
}

export const Trigger = ({ collapsed, onClick }: TriggerProps) => (
  <span
    onClick={onClick}
    className="ant-layout-sider-zero-width-trigger ant-layout-sider-zero-width-trigger-left"
  >
    {collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
  </span>
);
